// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// local
import styles from './SectionHeader.pcss';

export default class SectionHeader extends PureComponent {
  
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    image: PropTypes.node,
    imageClassname: PropTypes.string,
    reverse: PropTypes.bool,
  }
  static defaultProps = {
    reverse: true,
  }
  
  render() {
    const { children, className, image, imageClassname, reverse } = this.props;
    
    const imagClassname = classnames(styles.img, imageClassname);
    const imgEl = (typeof image === 'string')
      ? (<img alt={ 'icon' } className={ imagClassname } src={ image } />)
      : (<div className={ imagClassname } >{ image }</div>);

    
    const classNames = classnames(className, styles.sectionHeader, {
      [styles.reverse]: reverse,
    });
    
    return (
      <div className={ classNames }>
        <div className={ styles.left }>
          <h1>{ children }</h1>
        </div>
        <div className={ styles.right }>
          { imgEl }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SectionHeader/index.jsx